import { render, staticRenderFns } from "./hi-radio.vue?vue&type=template&id=8c417e1a"
import script from "./hi-radio.vue?vue&type=script&lang=ts"
export * from "./hi-radio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports